import Serializable from "Serializable";
import { CalendarType } from "../../../../../Constants/ListManagerCalendarConstants";

class CalendarViewSettings extends Serializable {

    constructor() {
        super();
        this.listViewType = CalendarType.NONE;
    }

    OnSeralisedInfoRecieved(serializedValue) {
        this.listViewType = serializedValue.listViewType ? serializedValue.listViewType : CalendarType.NONE;
    }

    getDataObject() {
        return {
            listViewType: this.listViewType,
        };
    }

    getObjectMapKey() {
        return "CalendarViewSettings";
    }

    getDefaultCalendarViewSettings() {
        this.listViewType = CalendarType.NONE;
        return this;
    }
}

export default CalendarViewSettings;
